import React, { useContext, useState } from 'react';
import { useNavigate, useSearchParams, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import Cookies from 'universal-cookie';
import Barcode from 'react-barcode';
import moment from 'moment';
import { Context } from "../../components/Context";

export default function Voucher() {
    const { t } = useTranslation();
    const cookies = new Cookies();
    window.document.title = `${t('Panda')}`;

    let lng = "en";
    if (cookies.get('lng') && cookies.get('lng') !== undefined) {
        lng = cookies.get('lng');
    }

    const { value, expiry } = useParams();
    const { handleSubmit, register, setValue, setFocus, setError, formState: { errors }, } = useForm();
    let [searchParams] = useSearchParams();

    const navigate = useNavigate();
    const [context, setContext] = useContext(Context);
    const [data, setData] = useState({ date: Date.now(), delay: 120000 });

    return (
        <>
            <div className="container">
                <div className="col-sm-12 pt-3">
                    <img src="https://images.todoorstep.com/loyalty/panda-plus-logo-en.svg" alt="logo" width="120" />
                    <h4 className="pt-2 px-1 text-green">Here is your voucher</h4>
                    <h6 className="pt-2 px-1">Expiry: 14-March-2023 23:59 P.M.</h6>
                    <h6 className="pt-2 px-1" dir="rtl">لانك عضو في بنده بلس، قدمنا لك خصم 50% على عرض خاص على مناديل الاطفال مصنعة بمياه نقية 100%او مناديل الاطفال بكريم نبات الصبار بنصف السعر</h6>
                    <h6 className="pt-2 px-1">Exclusively for you as a Panda Plus member, here's a voucher for 50% discount on Pampers Sensitive (56 ct) and Fresh Water Wipes (64 ct). </h6>
                    <h6 className="pt-2 px-1"><strong>T&C. Each voucher can be used only once.</strong></h6>
                    <h6 className="pt-2 px-1"><strong>يمكن استخدام كل قسيمة مرة واحدة فقط</strong></h6>
                </div>

                <div className="row d-flex justify-content-center px-3 pt-4">
                    <div className="col-md-6 col-sm-12  mb-3 order-2">
                        <div className="dashboard-para my-auto text-center">
                            <div className="dashboard-image" id="bar_code_section">
                                {<Barcode value={value} fontOptions="bold" background="#e8f3db" lineColor="#004a2c" width={1.7} height={100} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
